import axios from "axios";

// Empty backend URL keeps the API same-origin for a combined PHP deployment.
// Set REACT_APP_BACKEND_URL when the React build and PHP API use separate hosts.
export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("crm_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("crm_token");
      if (window.location.pathname.startsWith("/clinic")) { if (window.location.pathname !== "/clinic/login") window.location.href = "/clinic/login"; }
      else if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) return d.message;
  if (d.msg) return d.msg;
  return String(d);
}
